import { Actions } from './communities.actions'
import { fromJS } from 'immutable'
import * as CommunitiesTypes from './communities.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 20,
    },
    total: 0,
    results: 0,
  },
  createCommunity: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateCommunity: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function communitiesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case CommunitiesTypes.UPDATE_COMMUNITY_REQUEST: {
      return state.setIn(['updateCommunity', 'isLoading'], true)
    }

    case CommunitiesTypes.UPDATE_COMMUNITY_SUCCESS: {
      return state.setIn(['updateCommunity', 'isLoading'], false)
    }

    case CommunitiesTypes.UPDATE_COMMUNITY_FAILURE: {
      return state.setIn(['updateCommunity', 'isLoading'], false)
    }

    case CommunitiesTypes.CREATE_COMMUNITY_REQUEST: {
      return state.setIn(['createCommunity', 'isLoading'], true)
    }

    case CommunitiesTypes.CREATE_COMMUNITY_SUCCESS: {
      return state.setIn(['createCommunity', 'isLoading'], false)
    }

    case CommunitiesTypes.CREATE_COMMUNITY_FAILURE: {
      return state.setIn(['createCommunity', 'isLoading'], false)
    }

    case CommunitiesTypes.DELETE_COMMUNITY_REQUEST: {
      return state
    }

    case CommunitiesTypes.DELETE_COMMUNITY_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case CommunitiesTypes.DELETE_COMMUNITY_FAILURE: {
      return state
    }

    case CommunitiesTypes.FETCH_COMMUNITIES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case CommunitiesTypes.FETCH_COMMUNITIES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case CommunitiesTypes.FETCH_COMMUNITIES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case CommunitiesTypes.FETCH_COMMUNITY_REQUEST: {
      return state.setIn(['updateCommunity', 'isLoading'], true)
    }

    case CommunitiesTypes.FETCH_COMMUNITY_SUCCESS: {
      return state
        .setIn(['updateCommunity', 'isLoading'], false)
        .setIn(
          ['updateCommunity', 'data'],
          fromJS(action.payload).delete('streetType').delete('id'),
        )
    }

    case CommunitiesTypes.FETCH_COMMUNITY_FAILURE: {
      return state.setIn(['updateCommunity', 'isLoading'], false)
    }

    case CommunitiesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case CommunitiesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
